<c11n-button class="smart-continue" variant="primary" [colorMode]="isSecondary ? 'on-dark' : 'on-light'"
  [id]="continueButtonId" fullWidth="true" (clickEvent)="clickNext()" [labelText]="continueButton">
</c11n-button>
